/**
 * Cartop storefront file upload → Shopify Files via app proxy.
 * POST /apps/booking/upload  (multipart field: file)
 *
 * Markup:
 *   <div class="cc-upload" data-cartop-upload data-url-input="#field-id" data-alt="…">
 *     <input type="file" …>
 *     <input type="hidden" id="field-id" name="contact[…]" data-cartop-upload-urls>
 *     <p class="cc-upload__status" hidden></p>
 *   </div>
 */
(function () {
  if (window.__cartopFileUploadInit) return;
  window.__cartopFileUploadInit = true;

  var ENDPOINT = '/apps/booking/upload';
  var TOKEN_ENDPOINT = '/apps/booking/upload-token';
  var MAX_BYTES = 10 * 1024 * 1024;
  var ALLOWED = {
    'image/jpeg': true,
    'image/png': true,
    'image/webp': true,
    'image/gif': true,
    'image/heic': true,
    'image/heif': true,
    'application/pdf': true
  };
  var cachedToken = null;
  var cachedTokenExpires = 0;

  function mintUploadToken() {
    var now = Date.now();
    if (cachedToken && cachedTokenExpires - 30000 > now) {
      return Promise.resolve(cachedToken);
    }
    return fetch(TOKEN_ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || !data || !data.success || !data.token) {
          throw new Error((data && data.error) || 'Upload token ophalen mislukt');
        }
        cachedToken = data.token;
        cachedTokenExpires = data.expiresAt
          ? Date.parse(data.expiresAt) || now + 4 * 60 * 1000
          : now + 4 * 60 * 1000;
        return cachedToken;
      });
    });
  }

  function statusEl(root) {
    return root.querySelector('.cc-upload__status');
  }

  function setStatus(root, message, kind) {
    var el = statusEl(root);
    if (!el) return;
    if (!message) {
      el.hidden = true;
      el.textContent = '';
      el.className = 'cc-upload__status';
      return;
    }
    el.hidden = false;
    el.textContent = message;
    el.className = 'cc-upload__status' + (kind ? ' cc-upload__status--' + kind : '');
  }

  function urlInput(root) {
    var sel = root.getAttribute('data-url-input');
    if (sel) {
      var el = document.querySelector(sel);
      if (el) return el;
    }
    return root.querySelector('[data-cartop-upload-urls]');
  }

  function fileInput(root) {
    return root.querySelector('input[type="file"]');
  }

  function validate(file) {
    if (!file) return 'Geen bestand geselecteerd.';
    if (file.size > MAX_BYTES) return 'Bestand is groter dan 10 MB.';
    var type = (file.type || '').toLowerCase();
    if (!ALLOWED[type]) {
      var name = (file.name || '').toLowerCase();
      if (name.endsWith('.heic') || name.endsWith('.heif') || name.endsWith('.pdf')) {
        return null;
      }
      return 'Alleen JPEG, PNG, WebP, GIF, HEIC of PDF toegestaan.';
    }
    return null;
  }

  function uploadOne(file, alt) {
    return mintUploadToken().then(function (token) {
      var body = new FormData();
      body.append('file', file);
      body.append('upload_token', token);
      if (alt) body.append('alt', alt);
      return fetch(ENDPOINT, { method: 'POST', body: body, credentials: 'same-origin' }).then(
        function (res) {
          return res.json().then(function (data) {
            if (!res.ok || !data || !data.success) {
              if (res.status === 401) {
                cachedToken = null;
                cachedTokenExpires = 0;
              }
              var err = (data && data.error) || 'Upload mislukt';
              throw new Error(err);
            }
            return data;
          });
        }
      );
    });
  }

  function setBusy(root, busy) {
    root.classList.toggle('is-uploading', busy);
    var input = fileInput(root);
    var form = root.closest('form');
    if (input) input.disabled = busy;
    if (form) {
      var count = Number(form.dataset.cartopUploads || 0);
      count = busy ? count + 1 : Math.max(0, count - 1);
      form.dataset.cartopUploads = String(count);
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = count > 0;
    }
  }

  function handleChange(root) {
    var input = fileInput(root);
    var urlsField = urlInput(root);
    if (!input || !urlsField) return;

    var files = Array.prototype.slice.call(input.files || []);
    if (!files.length) {
      urlsField.value = '';
      setStatus(root, '');
      return;
    }

    for (var i = 0; i < files.length; i++) {
      var err = validate(files[i]);
      if (err) {
        setStatus(root, err, 'error');
        input.value = '';
        urlsField.value = '';
        return;
      }
    }

    var alt = root.getAttribute('data-alt') || '';
    var multiple = input.hasAttribute('multiple');
    setBusy(root, true);
    setStatus(root, 'Bezig met uploaden…', 'pending');

    var chain = Promise.resolve([]);
    files.forEach(function (file) {
      chain = chain.then(function (urls) {
        return uploadOne(file, alt || file.name).then(function (data) {
          urls.push(data.url);
          setStatus(
            root,
            'Geüpload: ' + urls.length + (multiple ? ' bestand(en)' : ''),
            'ok'
          );
          return urls;
        });
      });
    });

    chain
      .then(function (urls) {
        urlsField.value = urls.join(', ');
        setStatus(
          root,
          urls.length === 1
            ? 'Bestand geüpload.'
            : urls.length + ' bestanden geüpload.',
          'ok'
        );
      })
      .catch(function (e) {
        urlsField.value = '';
        input.value = '';
        setStatus(root, e.message || 'Upload mislukt', 'error');
      })
      .then(function () {
        setBusy(root, false);
      });
  }

  function wire(root) {
    if (root.dataset.cartopUploadWired === '1') return;
    root.dataset.cartopUploadWired = '1';
    var input = fileInput(root);
    if (!input) return;
    input.addEventListener('change', function () {
      handleChange(root);
    });
  }

  function ensureBody(form) {
    if (!form || form.dataset.cartopBodyWired === '1') return;
    form.dataset.cartopBodyWired = '1';
    form.addEventListener('submit', function (e) {
      var body = form.querySelector('[name="contact[body]"]');
      if (body && !(body.value || '').trim()) {
        var subject = form.querySelector('[name="contact[onderwerp]"]');
        body.value =
          ((subject && subject.value) || 'Formulier') + ' — zie overige velden in dit bericht.';
      }

      var requiredUploads = form.querySelectorAll('[data-cartop-upload][data-required="true"]');
      for (var i = 0; i < requiredUploads.length; i++) {
        var root = requiredUploads[i];
        var urlsField = urlInput(root);
        var input = fileInput(root);
        var urls = urlsField && (urlsField.value || '').trim();
        if (!urls) {
          e.preventDefault();
          var msg =
            root.getAttribute('data-required-message') ||
            'Upload minstens één bestand voordat u het formulier verstuurt.';
          setStatus(root, msg, 'error');
          if (input) {
            input.focus();
            if (typeof input.reportValidity === 'function') input.reportValidity();
          }
          root.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
      }

      if (Number(form.dataset.cartopUploads || 0) > 0) {
        e.preventDefault();
        alert('Wacht tot de upload klaar is voordat u het formulier verstuurt.');
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-cartop-upload]').forEach(wire);
    document.querySelectorAll('form.cc-form').forEach(ensureBody);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
